"use client";
import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { useQuery } from "@tanstack/react-query";
import { fetchDocumentsData } from "@/components/services/QueryDataHelper";

function MarketStatsPage() {
  const [ marketStatsUrl, setMarketStatsUrl ] = useState("");
  const { data, error, isLoading } = useQuery({
    queryKey: ["DOC-DATA"],
    queryFn: () => fetchDocumentsData("marketStats"),
    staleTime: 300000,
  });

  useEffect(() => {
    if(data?.Documents?.length>0)
    {
      setMarketStatsUrl(`${data?.BaseURL}${data?.Documents[0]}`);
    }
  }, [data]);

  const handleChange = (event: any) => {
    const val = event.target.value;
    setMarketStatsUrl(val);
  }

  return (
    <> 
      <section className="StyledSection">
      <Container>
          <Row>
              <Col>
                  <Card bg="trans-white">
                    <Card.Body>
                      <Card.Title><h1 className="blue-color">Housing Market Stats - RES Luxury Group Your Listing Specialists</h1></Card.Title>
                      <Card.Subtitle><h2>RES Luxury Group tracks local market stats and movement on a monthly basis.</h2></Card.Subtitle>
                      <Card.Text as="div">
                        <p className="indent">Each month you will have access to the newest market update. These market stats are very important to knowing how to effectively position your home for sale during any given market cycle. It’s equally important to stay informed of market changes when you have your home actively listed for sale. We recommend that you entrust your home sale process to an agent that tracks and monitors the area market stats on a regular and consistent basis. Contact us if you would like to discuss the current market stats and how this effects your home and your important plans for the future. RES Luxury Group is committed to partnering with our valued customers to bring the best results in each and every real estate transaction.</p>
                        <Form.Select className="w-100" onChange={handleChange} >
                          {(data?.Documents || []).map((doc:string, i:number) => {
                          return(
                            <option value={`${data?.BaseURL}${doc}`} key={i} selected={marketStatsUrl === `${data?.BaseURL}${doc}`} >{doc}</option>
                          )})}
                        </Form.Select>
                        <iframe className="w-100 min-vh-100" src={marketStatsUrl} allowFullScreen></iframe>                  
                      </Card.Text>                                                              
                    </Card.Body>
                  </Card>
              </Col>
          </Row>
      </Container>       
    </section>
  </>
  );
}

  
  export default MarketStatsPage;